<template>
  <transition name="modal-fade">
    <Modal @close="close">
      <div class="ly_pop_wrap fix">
        <div class="ly_pop_content ly_pop_libr">
          <div class="ly_pop_head">
            <h2>{{ $t('library.editmodal.4156') }}</h2>
            <a class="btn_ly_close svg_close" @click="close">
              <span>{{ $t('library.deletemodal.close') }}</span>
            </a>
          </div>
          <div class="ly_inner">
            <div class="editer_libr">
              <p>책장 이름을 수정하기</p>
              <div class="editer_form">
                <div class="editer_text_wrap n_line">
                  <input
                    v-model="newName"
                    class="editer_input_t"
                    :placeholder="$t('library.editmodal.2146')"
                  />
                </div>
                <span :class="`${inputState}_subtext`">{{ inputSubMsg }}</span>
              </div>
            </div>
            <div class="btn_wrap text-center">
              <button type="submit" class="box_btn" @click="update()">
                저장
              </button>
              <button type="submit" class="box_btn dull" @click="close">
                취소
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </transition>
</template>
<script>
import { BOOKSHELF_UPDATE, BOOKSHELF_GET_LIST } from '@/store/types'

export default {
  name: 'EditModal',
  props: {
    bookshelf: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newName: '',
      inputState: '',
      inputSubMsg: ''
    }
  },
  computed: {
    baseBookshelves() {
      return this.$store.getters.getBookshelves.filter(
        (e) => e.bookshelfTp !== 'GFT' && e.bookshelfTp !== 'PRS'
      )
    }
  },
  watch: {
    newName() {
      this.inputSubMsg = ''
    }
  },
  mounted() {
    // sets newName as old library name to prevent mutation
    this.newName = this.bookshelf.name
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async update() {
      const { newName, bookshelf } = this
      if (newName != '') {
        if (this.baseBookshelves.find((e) => e.bookshelfNm === newName)) {
          this.inputState = 'error'
          this.inputSubMsg = '이미 동일한 이름의 책장이 있습니다.'
          return
        }
        try {
          bookshelf.name = newName
          await this.$store.dispatch(BOOKSHELF_UPDATE, bookshelf)
          await this.$store.dispatch(BOOKSHELF_GET_LIST)
        } catch (e) {
          console.log(e)
        }
        // this.name = ''
        this.close()
      }

      // if (newName != '') {
      //   this.$store.dispatch(BOOKSHELF_UPDATE, bookshelf)
      //   this.close()
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
.box_btn {
  margin-left: 6px !important;
  margin-right: 6px !important;
}
.btn_wrap {
  display: flex;
}
.editer_libr + .btn_wrap .box_btn {
  height: 38px;
  font-size: 16px;
  color: #fff;
}
</style>
